import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { environment } from '../../../../environments/environment';

const apiServer = environment.apiServer;

@Injectable()
export class NavbarInfoService {

  constructor(private client: HttpClient) { }

  public get(): Observable<any> {
    return this.client.get(`${apiServer}/persone`);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/home/services/navbar-info.service.ts